import React,{useEffect} from "react";
import { motion } from "framer-motion";
import aboutUsHero from '../Images/about-hero.webp';
import whyChooseImg from '../Images/about-built-on-experience.webp';
import cta2Img from '../Images/cta-bg.webp';
import { ourApproach } from "../Data";
import OurNetwork from "../Components/OurNetwork";
import Whychoose from '../Components/WhyChoose';
import Cta2 from "../Components/Cta2";
import About from "../Components/About";

const AboutPg=()=>{
    useEffect(() => {
    document.title =
      "About Shivam Transworld | Trusted Logistics Partner";

    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
      metaDesc.setAttribute(
        "content",
        "Learn about Shivam Transworld, a transportation and logistics company with 11+ years of experience supporting businesses across India."
      );
    }

     const canonical = document.querySelector("link[rel='canonical']");
  if (canonical) {
    canonical.setAttribute("href", "https://shivamtransworld.in/about-us");
  }

  const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      "About Shivam Transworld | Trusted Logistics Partner"
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      "Learn about Shivam Transworld, a transportation and logistics company with 11+ years of experience supporting businesses across India."
    );
  }

  const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content", "https://shivamtransworld.in/about-us");
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      "https://shivamtransworld.in/image/home-about.webp"
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
      "About Shivam Transworld | Trusted Logistics Partner"
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
      "Learn about Shivam Transworld, a transportation and logistics company with 11+ years of experience supporting businesses across India."
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      "https://shivamtransworld.in/image/home-about.webp"
    );
  }
  }, []);
    return(
        <>
            <div className="spacing-div"></div>

              <About 
        subheading="ABOUT US"
        heading="About Shivam Transworld"
        headingTag="h1"
        subtext=" Shivam Transworld is a trusted transportation and logistics company
        providing efficient, reliable, and end-to-end logistics solutions
        across India. Established in 2014, with over 11+ years of industry
        experience, we specialize in full truck load, part truck load, and
        comprehensive logistics services. Backed by a strong network of 1000+
        vehicles, Pan-India coverage, and an experienced operations team, we
        ensure safe, timely, and cost-effective movement of goods for
        manufacturers, traders, and exporters across diverse industries."
        image={aboutUsHero}
        />

            {/**about shivam transworld section */}
          {/* <section className="about-us">
  <motion.div
    className="about-img-with-text"
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.3 }}
    variants={{
      hidden: {},
      visible: {
        transition: {
          staggerChildren: 0.2
        }
      }
    }}
  >
   
    <motion.div
      className="about-text-wrap"
      variants={{
        hidden: { opacity: 0, x: -50 },
        visible: {
          opacity: 1,
          x: 0,
          transition: { duration: 0.6, ease: "easeOut" }
        }
      }}
    >
      <motion.h1
        className="section-title"
        variants={{
          hidden: { opacity: 0, y: 20 },
          visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.5 }
          }
        }}
      >
        About Shivam Transworld
      </motion.h1>

      <motion.p
        className="section-text-about"
        variants={{
          hidden: { opacity: 0, y: 20 },
          visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6 }
          }
        }}
      >
        Shivam Transworld is a trusted transportation and logistics company
        providing efficient, reliable, and end-to-end logistics solutions
        across India. Established in 2014, with over 11+ years of industry
        experience, we specialize in full truck load, part truck load, and
        comprehensive logistics services. Backed by a strong network of 1000+
        vehicles, Pan-India coverage, and an experienced operations team, we
        ensure safe, timely, and cost-effective movement of goods for
        manufacturers, traders, and exporters across diverse industries.
      </motion.p>
    </motion.div>

  
    <motion.img
      src={aboutUsHero}
      alt="About Shivam Transworld"
      variants={{
        hidden: { opacity: 0, x: 50 },
        visible: {
          opacity: 1,
          x: 0,
          transition: { duration: 0.7, ease: "easeOut" }
        }
      }}
    />
  </motion.div>
</section>*/}


            {/**Our approach section */}
<section className="approach-section">
  {/* SECTION HEADING */}
  <motion.h2
    className="section-title"
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.3 }}
    transition={{ duration: 0.6, ease: "easeOut" }}
  >
    How We Approach Transportation & Logistics
  </motion.h2>

  {/* CARDS GRID */}
  <motion.div
    className="approach-grid"
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, amount: 0.3 }}
    variants={{
      hidden: {},
      visible: {
        transition: {
          staggerChildren: 0.15
        }
      }
    }}
  >
    {ourApproach.map((item, index) => (
      <motion.div
        className="approach-card"
        key={index}
        variants={{
          hidden: { opacity: 0, y: 40 },
          visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.5, ease: "easeOut" }
          }
        }}
        whileHover={{ y: -6 }}
      >
        <motion.div
          className="approach-icon"
          initial={{ scale: 0 }}
          whileInView={{ scale: 1 }}
          transition={{ duration: 0.4, ease: "backOut" }}
        >
        {item.icon}
        </motion.div>

        <h3>{item.title}</h3>
        <p>{item.desc}</p>
      </motion.div>
    ))}
  </motion.div>
</section>

      {/**our network-capability section */}
      <OurNetwork />

          {/**why choose us section */}
    <Whychoose
  heading="Built on Experience & Long-Term Partnerships"
  imageSrc={whyChooseImg}
  paragraph="With over 11 years of industry experience, Shivam Transworld has built strong, long-term partnerships by consistently delivering dependable and efficient logistics solutions. Our commitment to trust, transparency, and performance, combined with a deep understanding of transportation challenges, enables us to grow alongside our clients and support their evolving supply chain needs across India."
  listItems={[
    "11+ years of proven logistics expertise",
    "Long-standing client relationships",
    "Reliable and transparent operations",
    "Partnership-driven approach",
    "Consistent service quality across India"
  ]}
/>
    <Cta2 
    bgImage={cta2Img}/>

        </>
    )
}

export default AboutPg;